import request from '../request.js'

// 获取菜单信息
const selectAll = function (data) {
    return request({
        url: 'sysRole/selectAll',
        method: 'post',
        data
    })
}

const selectTree = function (data) {
    return request({
        url: 'sysRole/selectTree',
        method: 'post',
        data
    })
}

const saveOrUpdate = function (data) {
    return request({
        url: 'sysRole/saveOrUpdate',
        method: 'post',
        data
    })
}

const getInfoById = function (data) {
    return request({
        url: 'sysRole/getInfoById',
        method: 'post',
        data
    })
}

const deleteById = function (data) {
    return request({
        url: 'sysRole/deleteById',
        method: 'post',
        data
    })
}

const selectRoleTree = function (data) {
    return request({
        url: 'sysRole/selectRoleTree',
        method: 'post',
        data
    })
}

const saveOrUpdateRoleMenuBtn = function (data) {
    return request({
        url: 'sysRoleMenuBtn/saveOrUpdate',
        method: 'post',
        data
    })
}

const saveOrUpdateRoleMenu = function (data) {
    return request({
        url: 'sysRoleMenu/saveOrUpdate',
        method: 'post',
        data
    })
}

const getRoleMenuByRoleId = function (data) {
    return request({
        url: 'sysRoleMenu/getRoleMenuByRoleId',
        method: 'post',
        data
    })
}

const saveOrUpdateRoleDataPermission = function (data) {
    return request({
        url: 'sysRoleDataPermission/saveOrUpdate',
        method: 'post',
        data
    })
}

const getRoleDeptTree = function (data) {
    return request({
        url: 'sysRoleDataPermission/getRoleDeptTree',
        method: 'post',
        data
    })
}

const getAuthScopeData = function (data) {
    return request({
        url: 'sysRoleDataPermission/getAuthScopeData',
        method: 'post',
        data
    })
}

export {
    selectAll,
    selectTree,
    deleteById,
    getInfoById,
    saveOrUpdate,
    selectRoleTree,
    getRoleDeptTree,
    getAuthScopeData,
    getRoleMenuByRoleId,
    saveOrUpdateRoleMenu,
    saveOrUpdateRoleMenuBtn,
    saveOrUpdateRoleDataPermission
}
